<script>
import { Slider } from 'vue-sliderx';
import LoadingRing from '../shared/LoadingRing.vue';

export default {
  name: 'LanguageSelectBox',
  props: {
    languages: {
      required: true,
      type: Array,
    },
    locale: {
      type: String,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    waitingSave: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    Slider,
    LoadingRing,
  },
  data: () => ({
    perPage: 3,
    selectedLocale: null,
  }),
  methods: {
    onItemClick (locale) {
      this.selectedLocale = locale;
      this.$emit('change', locale);
    },
    save () {
      this.$gtm.trackEvent({
        category: 'Language',
        action: 'change',
        label: this.activeLocale.key,
      });
      this.$emit('save', this.activeLocale.key);
    },
  },
  computed: {
    currentLocale () { // TODO https://springboardvr.atlassian.net/browse/DEV-736
      return this.languages.find(({ key }) => key === this.locale);
    },
    localesToDisplay () { // we use this to display selected locale on top
      const localeIndex = this.languages.findIndex(({ key }) => key === this.locale); // TODO https://springboardvr.atlassian.net/browse/DEV-736
      return ~localeIndex
        ? [
          this.languages[localeIndex],
          ...this.languages.slice(0, localeIndex),
          ...this.languages.slice(localeIndex + 1),
        ]
        : this.languages;
    },
    activeLocale () {
      return this.selectedLocale || this.currentLocale;
    },
    dirty () {
      if (!this.selectedLocale) return false;
      return this.locale !== this.selectedLocale.key;
    },
  },
};
</script>

<template lang="pug">

  div.language-select-box.white.flex.flex-column
    header.header.cf.pa4.mt0.flex.flex-column.justify-between.flex-auto.h-0.relative.bg-black-overlay._collision
      div.loadingoverlay.absolute.absolute--fill.flex.justify-center.items-center.z-2.bg-black-overlay(v-if="waitingSave")
        loading-ring
      h1.title.fw7.f3.mb2.white {{ $t('Select Language') }}
      div.languages.flex-auto(v-if="!loading")
        slider.slider.h-100(:per-page="4", :navigation-increment="4", :clone="false", :loop="false")
          arrow-button.prev.center.db.rotate-180(slot="prev", slot-scope="{ canPrev, prev }", @click="prev", :style="{visibility: canPrev ? 'visible': 'hidden'}" small)
          span.row.db.w-100(v-for="({key, text}, index) in localesToDisplay", :key="key")
            button.languageitem.flex.ph3.pv3.b--white.relative.w-100.tl.bb(
              :class=`{
                '-active': activeLocale && activeLocale.key === key,
              }`,
              @click="onItemClick({ key, text })"
              type="button",
              data-hover-label="change language",
            )
                span.languagetext.flex-auto.f5 {{text}}
                icon.checkmarkicon.w1.h1.fill-green.animated.zoomIn(name="checkmark", v-if="activeLocale && activeLocale.key === key")
          arrow-button.next.center.db(slot="next", slot-scope="{ canNext, next }", @click="next", :style="{visibility: canNext ? 'visible': 'hidden'}", small)
    div.buttons.flex.mt2.flex-shrink-0
      cta-style
        button.cancelbtn.f5.pa3.w-50.mr2(type="button", :disabled="waitingSave",  @click="$router.goBack({ name: 'games-index' })") {{ $t('Back') }}
      cta-style(accent)
        button.savebtn.f5.bg-black-dark-overlay.pa3.w-50(v-sound="'progress'", type="button", :disabled="!dirty", @click="save")
          icon.checkmarkicon.mr2.w1.v-mid.fill-green(name="checkmark", :class="{disabled: !dirty}")
          span {{ $t('Save') }}

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";

.language-select-box {
  & .slider {
    height: 210px;
  }
  & .languageitem:after {
    content: attr(data-hover-label);
    visibility: hidden;
    position: absolute;
    right: 0;
    color: var(--green);
    font-size: 1.2rem;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }
  & .languageitem:hover:after {
    visibility: visible;
    opacity: 1;
  }
  & .languageitem.-active:after {
    visibility: hidden;
  }
  & .checkmarkicon.disabled {
    fill: rgba(255, 255, 255, 0.5);
  }
}
</style>
<style>
@import "styles/variables.css";

.language-select-box {
  & .slider {
    & .languageitem {
      &:hover,
      &.-active {
        color: var(--green);
      }
    }
  }
  & .slider .viewport {
    mask-image: linear-gradient(
      to bottom,
      transparent 0%,
      transparent 5%,
      #000000 8%,
      #000000 92%,
      transparent 95%,
      transparent 100%
    );
    /*NOTE HACK POLYFILL*/
  }
}
</style>
